import '../lib/typedef';
import { buildQuery } from '../lib/helper';
import client from '../lib/http-client';

const endpoint = '/resellers/tiers';

export default {
	/**
	 * Fetch All Contacts
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {boolean} params.is_paid Paid Status
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.product_id] Product Id
	 * @param {string} params.reminder_date Reminder Date
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getResellerTiers(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	getResellerProductTiers(id, cb, errorCb) {
		const url = `${endpoint}/product/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	checkLevel(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/check/level?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	checkThresholdValue(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/check/threshold-value?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	checkLastLevel(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/check/last-level?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Contact Detail
	 *
 	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	show(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Store/Create Contact Manually
	 *
	 * @param {Object} params
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {string} params.customer_data.label Customer Address Label
	 * @param {string} params.customer_data.receiver_name Customer Address Receiver Name
	 * @param {string} params.customer_data.province_id Customer Address Province ID
	 * @param {string} params.customer_data.province_name Customer Address Province Name
	 * @param {string} params.customer_data.city_id Customer Address City ID
	 * @param {string} params.customer_data.city_name Customer Address City Name
	 * @param {string} params.customer_data.city_name_with_type Customer Address City Name With Type
	 * @param {string} params.customer_data.subdistrict_id Customer Address Subdistrict ID
	 * @param {string} params.customer_data.subdistrict_name Customer Address Subdistrict Name
	 * @param {string} params.customer_data.address Customer Address
	 * @param {'customer' | 'reseller' | 'distributor' | 'affiliate'} params.type Customer Type
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	store(params, cb, errorCb) {
		const url = `${endpoint}`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Single Delete Contact
	 *
	 *
	 * @param {Object} id ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	delete(id, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.delete(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Delete Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.customer_ids Array of Contacts ID
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	 */
	bulkDelete(ids = [], cb, errorCb) {
		const url = endpoint;

		const idsJSON = JSON.stringify(ids);
		const params = {
			tier_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Export Contact
	 *
	 * @param {Object} params
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	export(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}/export?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) {
					cb(response.data);
				}
			})
			.catch((e) => {
				if (errorCb) {
					errorCb(e);
				} else {
					// eslint-disable-next-line
					console.log(e);
				}
			});
	},

	/**
	 * Single Update Contact
	 *
	 * @param {string} id Contact ID
	 * @param {Object} params
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {string} params.customer_data.label Customer Address Label
	 * @param {string} params.customer_data.receiver_name Customer Address Receiver Name
	 * @param {string} params.customer_data.province_id Customer Address Province ID
	 * @param {string} params.customer_data.province_name Customer Address Province Name
	 * @param {string} params.customer_data.city_id Customer Address City ID
	 * @param {string} params.customer_data.city_name Customer Address City Name
	 * @param {string} params.customer_data.city_name_with_type Customer Address City Name With Type
	 * @param {string} params.customer_data.subdistrict_id Customer Address Subdistrict ID
	 * @param {string} params.customer_data.subdistrict_name Customer Address Subdistrict Name
	 * @param {string} params.customer_data.address Customer Address
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	update(id, params, cb, errorCb) {
		const url = `${endpoint}/${id}`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Update Contacts
	 *
	 * @param {Object} params
	 * @param {string[]} params.customer_ids Array of Contacts ID
	 * @param {Object} params.customer_data Customer Data
	 * @param {string} params.customer_data.name Customer Data Name
	 * @param {string} params.customer_data.email Customer Data Email
	 * @param {string} params.customer_data.picture Customer Data Picture
	 * @param {string[]} params.customer_data.tags Customer Data Tag
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	updateBulk(params, cb, errorCb) {
		const url = `${endpoint}/bulk`;
		client
			.put(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch All Activities
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'_id' | 'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} params.page Page
	 * @param {string} params.since Date Since
	 * @param {string} params.until Date Until
	 * @param {string} [params.keyword] Search Keyword
	 * @param {string} [params.product_id] Product Id
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getActivities(params, cb, errorCb) {
		const query = buildQuery(params.query);
		const url = `${endpoint}/${params.id}/activity?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Create Activity Manually
	 *
	 * @param {Object} params
	 * @param {string} params.customer_ids ID Customer
	 * @param {'note' | 'send_email_message' | 'send_wa_message' | 'send_sms_message' | 'reminder'} params.type Activity Type
	 * @param {string} params.title Activity Note Title
	 * @param {string} params.description Activity Note/SMS/Wa Description
	 * @param {string} params.reminder_date Reminder Date
	 * @param {string} params.text Activity  Email Text
	 * @param {string} params.subject Activity  Email Subject
	 * @param {string} params.email_from Activity  Email From
	 * @param {string} params.email_to Activity  Email To
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	storeActivity(params, cb, errorCb) {
		const url = `${endpoint}/activity`;
		client
			.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Bulk Upload Contacts
	 *
	 * @param {Object} params
	 * @param {Object} params.file Contact CSV File
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	uploadContact(params, cb, errorCb) {
		const url = `${endpoint}/upload_contacts`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	 * Fetch Search Contacts
	 *
	 * @param {Object} params
	 * @param {number} params.limit Limit
	 * @param {'created_at'} params.sort_by Created By
	 * @param {'desc' | 'asc'} params.sort Sort
	 * @param {string} [params.keyword] Search Keyword
	 * @param {requestCallback} cb
	 * @param {errorCallback} errorCb
	*/
	getSeacrhContacts(params, cb, errorCb) {
		const query = buildQuery(params);
		const url = `${endpoint}?${query}`;
		client
			.get(url)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},

	/**
	* Bulk Delete Contact Activities
	*
	* @param {Object} params
	* @param {string[]} params.customer_ids Array of Contacts ID
	* @param {requestCallback} cb
	* @param {errorCallback} errorCb
	*/
	deleteActivities(ids = [], cb, errorCb) {
		const url = `${endpoint}/activity`;

		const idsJSON = JSON.stringify(ids);
		const params = {
			activity_ids: idsJSON,
		};

		client
			.delete(url, { data: params })
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
